import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { baseUrl } from '../components/constant';
import { toast } from 'react-toastify';

const Ads = () => {
  const [Images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const navigate = useNavigate();

  const fetchSliderImages = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/categories/category-images`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("data",data)
        setImages(data.categories_images); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch Ads');
      }
    } catch (err) {
      setError('Failed to fetch Ads');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSliderImages();
  }, []);

 
  const handleDeleteClick = (category) => {
    setCategoryToDelete(category);
    setShowModal(true);
  };

  const confirmDelete = async () => {
    if (!categoryToDelete) return;

    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/categories/category-images/${categoryToDelete.id}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        toast.success('Ad deleted successfully!');
        setImages(Images.filter(category => category.id !== categoryToDelete.id));
        setShowModal(false); // Close the modal after successful deletion
      } else {
        toast.error('Failed to delete Ad');
      }
    } catch (err) {
      toast.error('An error occurred while deleting the Ad.');
    } finally {
      setLoading(false);
    }
  };

  const cancelDelete = () => {
    setShowModal(false);
    setCategoryToDelete(null);
  };

  const handleAddNewCategory = () => {
    navigate('/Ads/New');
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="dashboard">
      <button className="add-category-button" onClick={handleAddNewCategory} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>
        <FontAwesomeIcon icon={faPlus} /> Add New image
      </button>
      <div className="category-list">
        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}


        {!loading && Images.map(category => (
          <div key={category.id} className="category-item">

            
            <div className="category-row">
              <span className="category-id">ID: {category.id}</span>
              <img src={'https://dashboard.onyxen-regalia.com/backend/storage/'  + category.image_path} alt={category.name} className="category-image" />
              <div style={{flexGrow: 1}}>
              <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>link : {category.link}</h3>
                </div>
             
              <div className="buttons">
              {/* <button className="edit" onClick={() => handleEditClick(category)}>
                  <FontAwesomeIcon icon={faEdit} color='rgb(154, 57, 57)' />
                </button> */}
                <button className="delete" onClick={() => handleDeleteClick(category)}>
                  <FontAwesomeIcon icon={faTrashAlt} color='#000' />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

 {lastPage > 1 && 
 
      <div className="pagination-controls">
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          style={{ marginRight: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
        >
          Previous
        </button>
        <span>Page {currentPage} of {lastPage}</span>
        <button
          onClick={handleNextPage}
          disabled={currentPage === lastPage}
          style={{ marginLeft: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
        >
          Next
        </button>
      </div>
 }

      {showModal && (
        <div className="modal show">
          <div className="modal-content">
            <h3 style={{ color: '#000' }}>Are you sure you want to delete this image?</h3>
            <button className="cancel-button" onClick={cancelDelete} style={{ backgroundColor: "#000" }}>Cancel</button>
            <button className="delete-button" onClick={confirmDelete} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>Delete</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ads;
